<section class="pit-card pit-card--flush">
  <div class="comparison__head">
    <h3 class="pit-title">Comparativo entre sócios</h3>
    <p class="pit-caption">{{ caption() }}</p>
  </div>
  <div class="pit-table-wrap">
    <table class="pit-table comparison__table">
      <thead>
        <tr>
          <th>Sócio</th>
          @if (showShare()) {
            <th class="num">Part.</th>
          }
          @for (year of years(); track year) {
            <th class="num">PL {{ year }}</th>
          }
          <th class="num">Média a.a.</th>
          <th class="num">Dívidas</th>
          @if (policyDefined()) {
            <th class="num">Garantia livre</th>
            <th class="num">Sem restrição</th>
          }
        </tr>
      </thead>
      <tbody>
        @for (item of rows(); track item.row.personId) {
          <tr>
            <td>
              <button type="button" class="pit-link" (click)="openPartner.emit(item.row.personId)">
                {{ item.displayName }}
              </button>
              @if (item.row.role) {
                <p class="pit-caption">{{ item.row.role }}</p>
              }
            </td>
            @if (showShare()) {
              <td class="num">{{ share(item.row.sharePercent) }}</td>
            }
            @for (value of item.values; track $index; let last = $last) {
              <td class="num" [class.is-current]="last">{{ value }}</td>
            }
            <td
              class="num is-current"
              [class.pit-positive]="tone(item.row.cagr) === 'positive'"
              [class.pit-negative]="tone(item.row.cagr) === 'negative'">
              <!-- Média a.a. inteira, como os outros percentuais das tabelas (revisão de 29/10/2026). -->
              {{ ratio(item.row.cagr, 0, true) }}
            </td>
            <td class="num">
              <!-- Sem dívida: "—", sem "0% do PL" (N5). -->
              {{ item.row.debts ? thousands(item.row.debts) : '—' }}
              @if (item.row.debts && item.row.debtsOverNetWorth !== null) {
                <span class="pit-caption comparison__block"
                  >{{ ratio(item.row.debtsOverNetWorth) }} do PL</span
                >
              }
            </td>
            @if (policyDefined()) {
              <td class="num is-current">{{ thousands(item.row.freeCollateral) }}</td>
              <td class="num is-current">{{ thousands(item.unrestricted) }}</td>
            }
          </tr>
        }
      </tbody>
      <tfoot>
        <tr class="is-total">
          <td>Total</td>
          @if (showShare()) {
            <td class="num">{{ share(shareTotal()) }}</td>
          }
          @for (value of totals(); track $index) {
            <td class="num">{{ value }}</td>
          }
          <td class="num" [class.pit-positive]="tone(consolidated().netWorthCagr) === 'positive'">
            {{ ratio(consolidated().netWorthCagr, 0, true) }}
          </td>
          <td class="num">{{ thousands(consolidated().debtsTotal) }}</td>
          @if (policyDefined()) {
            <td class="num">{{ thousands(consolidated().freeCollateralTotal) }}</td>
            <td class="num">{{ thousands(consolidated().unrestrictedCollateralTotal) }}</td>
          }
        </tr>
      </tfoot>
    </table>
  </div>
  @if (hasPartialYears()) {
    <p class="pit-caption comparison__note">
      Total só nos anos em que todos os sócios têm declaração.
    </p>
  }
</section>
